export const loginUrlKey = "loginUrl";
